import theme from '../../base';

const modal = {
  overlayBackground: theme.colors.neutrals.gray900,
  overlayOpacity: theme.colors.opacity.opacity90,
};

export default modal;
